function FetchResponseRdc() {
    const fetchResponseRdc = (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: false });
    };
    return fetchResponseRdc;
}
export default FetchResponseRdc;
//# sourceMappingURL=FetchErrorRdc.js.map